import { fromJS } from "immutable";

import TYPE from "../../constants/type";

const initialState = fromJS({
  list: [],
  listById: [],
  listFiltered: [],
  isFetching: false,
  isFetchingAccepted: false,
});

export default function programDirectorReducer(state = initialState, action) {
  switch (action.type) {
    case TYPE.PROGRAM_DIRECTOR.GET_ALL_PROGRAM_DIRECTOR_LOADING:
    case TYPE.PROGRAM_DIRECTOR.GET_FILTERED_PROGRAM_DIRECTOR_LOADING:
    case TYPE.PROGRAM_DIRECTOR.GET_ALL_PROGRAM_DIRECTOR_BY_PROFILE_ID_LOADING:
    case TYPE.PROGRAM_DIRECTOR.INSERT_PROGRAM_DIRECTOR_LOADING:
    case TYPE.PROGRAM_DIRECTOR.UPDATE_PROGRAM_DIRECTOR_LOADING:
    case TYPE.PROGRAM_DIRECTOR.DELETE_PROGRAM_DIRECTOR_LOADING:
      return state.merge({
        isFetching: true,
      });

    case TYPE.PROGRAM_DIRECTOR.ACCEPT_PROGRAM_DIRECTOR_LOADING:
      return state.merge({
        isFetchingAccepted: true,
      });

    case TYPE.PROGRAM_DIRECTOR.GET_ALL_PROGRAM_DIRECTOR_FAILURE:
    case TYPE.PROGRAM_DIRECTOR.GET_FILTERED_PROGRAM_DIRECTOR_FAILURE:
    case TYPE.PROGRAM_DIRECTOR.GET_ALL_PROGRAM_DIRECTOR_BY_PROFILE_ID_FAILURE:
    case TYPE.PROGRAM_DIRECTOR.INSERT_PROGRAM_DIRECTOR_FAILURE:
    case TYPE.PROGRAM_DIRECTOR.UPDATE_PROGRAM_DIRECTOR_FAILURE:
    case TYPE.PROGRAM_DIRECTOR.DELETE_PROGRAM_DIRECTOR_FAILURE:
      return state.merge({
        isFetching: false,
      });

    case TYPE.PROGRAM_DIRECTOR.ACCEPT_PROGRAM_DIRECTOR_FAILURE:
      return state.merge({
        isFetchingAccepted: false,
      });

    case TYPE.PROGRAM_DIRECTOR.GET_ALL_PROGRAM_DIRECTOR_SUCCESS:
      return state.merge({
        list: action.payload || [],
        isFetching: false,
      });

    case TYPE.PROGRAM_DIRECTOR.GET_FILTERED_PROGRAM_DIRECTOR_SUCCESS:
      return state.merge({
        listFiltered: action.payload || [],
        isFetching: false,
      });

    case TYPE.PROGRAM_DIRECTOR.GET_ALL_PROGRAM_DIRECTOR_BY_PROFILE_ID_SUCCESS:
      return state.merge({
        listById: [...action.payload],
        isFetching: false,
      });

    case TYPE.PROGRAM_DIRECTOR.INSERT_PROGRAM_DIRECTOR_SUCCESS: {
      const newlistById = state.get("listById");
      const index = action.payload.programDirectorProfile.findIndex((e) => e.profileId === action.id);
      if (index >= 0) newlistById.push({ programDirector: action.payload });
      return state.merge({
        listById: [...newlistById],
        listFiltered: [...state.get("listFiltered"), { programDirector: action.payload }],
        isFetching: false,
      });
    }

    case TYPE.PROGRAM_DIRECTOR.UPDATE_PROGRAM_DIRECTOR_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.programDirector.id === action.id);
      newList.splice(index, 1, { programDirector: action.payload });

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.programDirector.id === action.id);
      newList1.splice(index1, 1, { programDirector: action.payload });

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetching: false,
      });
    }

    case TYPE.PROGRAM_DIRECTOR.DELETE_PROGRAM_DIRECTOR_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.programDirector.id === action.id);
      if (index !== -1) newList.splice(index, 1);

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.programDirector.id === action.id);
      if (index1 !== -1) newList1.splice(index1, 1);

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetching: false,
      });
    }

    case TYPE.PROGRAM_DIRECTOR.ACCEPT_PROGRAM_DIRECTOR_SUCCESS: {
      const newList = state.get("listById");
      const index = newList.findIndex((e) => e.programDirector.id === action.payload.id);
      const newProgramDirector = { ...newList[index], programDirector: action.payload };
      newList.splice(index, 1, newProgramDirector);

      const newList1 = state.get("listFiltered");
      const index1 = newList1.findIndex((e) => e.programDirector.id === action.payload.id);
      const newProgramDirector1 = { ...newList1[index1], programDirector: action.payload };
      newList1.splice(index1, 1, newProgramDirector1);

      return state.merge({
        listById: [...newList],
        listFiltered: [...newList1],
        isFetchingAccepted: false,
      });
    }

    default:
      return state;
  }
}

